import { render, staticRenderFns } from "./SubmittedResults.vue?vue&type=template&id=664f7490&scoped=true"
import script from "./SubmittedResults.vue?vue&type=script&lang=ts"
export * from "./SubmittedResults.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664f7490",
  null
  
)

export default component.exports